export default __webpack_public_path__ + "static/media/LMS.a206067c.jpg";